/**
 * Format API error responses for display in the UI
 * Handles FastAPI validation errors (422) which return arrays of error objects
 * @param {Error} err - The error object from axios or fetch
 * @param {string} defaultMessage - Default message if error cannot be parsed
 * @returns {string} - Formatted error message
 */
export const formatApiError = (err, defaultMessage = 'An error occurred') => {
  if (err.response?.data?.detail) {
    const detail = err.response.data.detail;
    
    // If detail is an array (FastAPI validation errors)
    if (Array.isArray(detail)) {
      return detail.map(e => {
        const field = e.loc ? e.loc.join(' > ') : 'Unknown field';
        return `${field}: ${e.msg}`;
      }).join(', ');
    } 
    // If detail is a string
    else if (typeof detail === 'string') {
      return detail;
    }
    // If detail is an object with a message
    else if (typeof detail === 'object' && detail.message) {
      return detail.message;
    }
  } else if (err.message) {
    return err.message;
  }
  
  return defaultMessage;
};
